// Category hubs (Phase 2) — each links to relevant medications + sub-categories
export const HUBS = {
  "weight-loss": {
    slug: "weight-loss", name: "WEIGHT LOSS", accent: "pink",
    eyebrow: "GLP-1 Programs · Sustainable Loss",
    tagline: "Clinically guided weight loss — built on the most powerful protocols in modern medicine.",
    intro: "Weight loss at BestRx isn't a diet plan or a coaching package. It's prescription medicine — semaglutide, tirzepatide, oral GLP-1, lipotropic support — reviewed and titrated by a licensed clinician for your body and your goals. The result: 15–25% body-weight reduction on average, sustained over 12 months and beyond.",
    meds: ["semaglutide", "tirzepatide", "oral-glp1", "mic-b12", "l-carnitine"],
    related: ["peptides", "longevity"],
    benefits: [
      { title: "GLP-1 medicine, not lifestyle advice", body: "Prescription protocols designed for measurable weight loss." },
      { title: "Clinician-led titration", body: "Doses are stepped up and adjusted by a licensed provider — not generic." },
      { title: "Quarterly bloodwork", body: "Track A1C, lipids, hormones — see the health improvements behind the weight." },
      { title: "Ongoing care, 12 months", body: "Care doesn't end after delivery. Monthly check-ins included." },
    ],
    faq: [
      { q: "How much weight can I lose?", a: "Clinical averages: 15% (semaglutide), 22% (tirzepatide) over 12 months. Outcomes vary." },
      { q: "Will I gain it back?", a: "Patients who continue treatment + lifestyle support maintain loss. Sudden discontinuation can cause rebound." },
      { q: "Insurance?", a: "No insurance required. Flat monthly pricing through partnered compounding pharmacies." },
      { q: "How fast can I start?", a: "Assessment takes 4 minutes, clinician review within 24 hours, medication shipped in 3–5 days." },
    ],
  },
  peptides: {
    slug: "peptides", name: "PEPTIDES", accent: "blue",
    eyebrow: "Targeted Performance · Recovery · Longevity",
    tagline: "Precision protocols using the most-studied research peptides in modern medicine.",
    intro: "Peptides are short chains of amino acids that signal specific outcomes — muscle repair, fat metabolism, sleep, libido, longevity. Used responsibly under clinician oversight, they're some of the most powerful tools in performance medicine. BestRx prescribes only what the data supports.",
    meds: ["pt-141", "mic-b12", "l-carnitine"],
    related: ["mens-health", "recovery", "longevity"],
    benefits: [
      { title: "Research-backed", body: "We prescribe peptides with peer-reviewed evidence — not internet stacks." },
      { title: "Clinician-titrated", body: "Personalized dosing protocols, not one-size-fits-all." },
      { title: "Compounded by partnered pharmacies", body: "Sterile, FDA-regulated compounding — not gray-market gear." },
      { title: "Quarterly lab tracking", body: "Bloodwork to confirm safety, efficacy, and adjustment opportunities." },
    ],
    faq: [
      { q: "Are peptides legal?", a: "Prescribed compounded peptides are legal when written by a licensed clinician for an FDA-recognized indication." },
      { q: "Will I have to inject?", a: "Most peptides are subcutaneous injections — small insulin-needle doses, often self-administered." },
      { q: "Side effects?", a: "Generally mild and short-lived. Discussed at intake and monitored." },
      { q: "Stack with TRT?", a: "Common. Your clinician will design the protocol." },
    ],
  },
  "mens-health": {
    slug: "mens-health", name: "MEN'S HEALTH", accent: "blue",
    eyebrow: "Testosterone · Performance · Recovery",
    tagline: "Engineered protocols for men who want to feel and perform like the best version of themselves.",
    intro: "Men's Health at BestRx covers the protocols men actually want answered: TRT, performance, hair, sleep, recovery, libido. Every program is bloodwork-driven, clinician-titrated, and built around your actual body — not pulled from a generic playbook.",
    meds: ["testosterone", "enclomiphene", "tadalafil", "sildenafil", "pt-141", "anastrozole", "brogaine"],
    related: ["weight-loss", "peptides", "hair-restoration", "recovery", "longevity"],
    benefits: [
      { title: "Bloodwork-driven", body: "TRT, enclomiphene, anastrozole — all prescribed based on YOUR labs, not assumptions." },
      { title: "Clinician-led, lab-monitored", body: "Quarterly labs included. We adjust based on data." },
      { title: "Compounded options", body: "Cost-effective compounded formulations from partnered pharmacies." },
      { title: "Discreet shipping", body: "Plain packaging. No mention of BestRx or the medication outside." },
    ],
    faq: [
      { q: "Do I need bloodwork?", a: "For TRT, enclomiphene, and anastrozole — yes. We order it, you take it at any LabCorp or Quest." },
      { q: "Is TRT permanent?", a: "Often. TRT replaces testosterone your body stops producing. Discontinuation returns you to baseline." },
      { q: "Can I use TRT and stay fertile?", a: "TRT can suppress fertility. Adjuncts like HCG or enclomiphene preserve it. Discussed at intake." },
      { q: "What if I have side effects?", a: "Message your care team anytime. Adjustments are normal early on." },
    ],
  },
  "womens-health": {
    slug: "womens-health", name: "WOMEN'S HEALTH", accent: "pink",
    eyebrow: "Hormones · Energy · Confidence",
    tagline: "Medically guided programs in hormone balance, weight, skin, hair, and longevity — built for women.",
    intro: "Women's Health at BestRx isn't a Pinterest wellness plan. It's prescription medicine reviewed by clinicians who understand female physiology — weight loss with GLP-1, HRT for perimenopause and beyond, libido, skin, hair, and longevity protocols. Real medicine. Real outcomes.",
    meds: ["semaglutide", "tirzepatide", "oral-glp1", "mic-b12", "pt-141", "dhea"],
    related: ["weight-loss", "skin-care", "hair-restoration", "longevity"],
    benefits: [
      { title: "Built for female physiology", body: "Programs designed around women's hormones, body comp, and goals." },
      { title: "HRT, GLP-1, libido, longevity", body: "Real options for the issues that actually impact your life." },
      { title: "No-clinic telehealth", body: "Skip the OB-GYN wait. Take the assessment from your phone." },
      { title: "Quarterly labs included", body: "Track estradiol, progesterone, T, DHEA-S, A1C and more." },
    ],
    faq: [
      { q: "Is HRT safe?", a: "Modern HRT, prescribed correctly, has a strong safety profile. Discussed in-depth at intake." },
      { q: "Pregnant or trying?", a: "Many of our protocols are contraindicated. Tell your clinician at intake." },
      { q: "Insurance?", a: "Not required. Flat monthly pricing." },
      { q: "How fast can I start?", a: "Assessment in 4 minutes. Clinician review within 24 hours." },
    ],
  },
  "hair-restoration": {
    slug: "hair-restoration", name: "HAIR RESTORATION", accent: "blue",
    eyebrow: "Oral · Topical · Combination",
    tagline: "Compounded protocols for hair loss — measurable regrowth in months, not maybes.",
    intro: "Hair loss is medical, not cosmetic. BestRx prescribes the protocols with the strongest evidence: oral minoxidil (OMG Caps), topical compounded minoxidil + finasteride (Brogaine), and prescription adjuncts. 92% of patients see visible regrowth by month 6.",
    meds: ["omg-caps", "brogaine"],
    related: ["mens-health", "womens-health", "skin-care"],
    benefits: [
      { title: "Oral + topical options", body: "Modern protocols deliver real results — not just thicker shampoo." },
      { title: "Compounded for you", body: "Combined formulas you can't buy off the shelf." },
      { title: "Photo + lab tracking", body: "Quarterly progress reviews with your clinician." },
      { title: "Side-effect-aware", body: "Topical finasteride offers regrowth with minimal systemic exposure." },
    ],
    faq: [
      { q: "When will I see results?", a: "Most patients see visible regrowth by month 4–6. Earlier on photos than mirror." },
      { q: "Will I have to stay on it?", a: "Hair regrowth is dose-dependent. Most patients stay on long-term." },
      { q: "Will my hair fall out faster?", a: "Some patients shed for 4–8 weeks as the hair cycle resets. Normal." },
      { q: "Topical vs. oral?", a: "Both work. Topical = lower systemic exposure. Oral = simpler adherence." },
    ],
  },
  "skin-care": {
    slug: "skin-care", name: "SKIN CARE", accent: "pink",
    eyebrow: "Compounded Tretinoin · Tone · Pigment",
    tagline: "Prescription dermatology — designed for your skin, not for sale on a shelf.",
    intro: "BestRx skin protocols use prescription-strength tretinoin, tranexamic acid, hydroquinone, and compounded formulas designed for tone, texture, hyperpigmentation, and aging. Real molecules. Real results. Reviewed and refined by clinicians.",
    meds: [],
    related: ["womens-health", "hair-restoration", "longevity"],
    benefits: [
      { title: "Prescription tretinoin", body: "The gold standard for anti-aging and texture." },
      { title: "Compounded for your skin", body: "Custom strength, custom adjuncts." },
      { title: "Tone & pigment protocols", body: "Tranexamic, hydroquinone, kojic — combinations the OTC world can't match." },
      { title: "Clinician follow-up", body: "We adjust strength as your skin builds tolerance." },
    ],
    faq: [
      { q: "How long until results?", a: "Texture: 4–8 weeks. Tone/pigment: 8–16 weeks. Anti-aging: 6+ months." },
      { q: "Can I use it with hair protocols?", a: "Yes — different application zones, no interaction." },
      { q: "Side effects?", a: "Initial dryness/flaking common — fades as skin acclimates." },
      { q: "Safe long-term?", a: "Yes — tretinoin is one of the most-studied dermatology molecules." },
    ],
  },
  longevity: {
    slug: "longevity", name: "LONGEVITY", accent: "yellow",
    eyebrow: "Healthspan · Vitality · Optimization",
    tagline: "Live longer. Feel better doing it. Protocols for the long game.",
    intro: "Longevity at BestRx isn't bio-hacker theater. It's the protocols and labs that move the needle on healthspan: bloodwork-driven hormone optimization, DHEA, metabolic markers, GLP-1 for inflammation, peptides for repair. Built for people who plan to live well.",
    meds: ["dhea", "mic-b12", "semaglutide", "testosterone"],
    related: ["mens-health", "womens-health", "peptides", "recovery"],
    benefits: [
      { title: "Bloodwork-driven", body: "Comprehensive panels every quarter. Track what matters." },
      { title: "Hormonal optimization", body: "Restore declining hormones with lab-driven precision." },
      { title: "Inflammation control", body: "GLP-1, peptides, and adjuncts that improve metabolic age." },
      { title: "Built for the long game", body: "Multi-year programs, ongoing care, real continuity." },
    ],
    faq: [
      { q: "How is this different from a wellness program?", a: "We prescribe FDA-approved and compounded medications, not just supplements." },
      { q: "How often is bloodwork?", a: "Quarterly for most patients on optimization protocols." },
      { q: "Stack with weight loss?", a: "Common — GLP-1 for weight loss, DHEA + adjuncts for vitality." },
      { q: "Cost?", a: "Transparent monthly pricing. No insurance billing." },
    ],
  },
  recovery: {
    slug: "recovery", name: "RECOVERY", accent: "blue",
    eyebrow: "Sleep · Repair · Bounceback",
    tagline: "Rebuild what training breaks down. Recover faster. Train harder.",
    intro: "Recovery isn't passive. BestRx prescribes the protocols that move recovery metrics: sleep medicine, peptide therapy for soft tissue and muscle repair, MIC+B12 and L-Carnitine for cellular recovery, hormone optimization. Stack-ready, clinician-managed, designed for people who train.",
    meds: ["mic-b12", "l-carnitine", "testosterone", "dhea"],
    related: ["mens-health", "peptides", "longevity"],
    benefits: [
      { title: "Deeper sleep", body: "Prescription sleep protocols that don't wreck mornings." },
      { title: "Tissue repair", body: "Peptide-assisted soft-tissue and joint recovery." },
      { title: "Hormone-driven recovery", body: "Optimize T, DHEA, and growth signals to recover faster." },
      { title: "Real measurement", body: "Quarterly labs to track recovery markers and HRV." },
    ],
    faq: [
      { q: "Will this help my soreness?", a: "Most patients report noticeably less soreness and faster bounceback within 4–8 weeks." },
      { q: "Stack with TRT?", a: "Common — TRT is one of the most powerful recovery tools when clinically indicated." },
      { q: "Safe for athletes?", a: "Some protocols are flagged on sports-testing panels. Tell your clinician at intake." },
      { q: "What about HGH?", a: "We don't prescribe rDNA HGH. We use peptide growth-signal protocols where appropriate." },
    ],
  },
  wellness: {
    slug: "wellness", name: "WELLNESS", accent: "yellow",
    eyebrow: "Energy · Metabolism · Vitality",
    tagline: "Clinician-guided wellness — energy, metabolism and recovery, backed by real medicine.",
    intro: "Wellness at BestRx means prescription-grade support for energy, fat metabolism and recovery — MIC+B12, L-Carnitine and DHEA, reviewed and dosed by a licensed clinician. Not shelf supplements: compounded protocols designed around your labs and goals.",
    meds: ["mic-b12", "l-carnitine", "dhea"],
    related: ["longevity", "recovery", "weight-loss"],
    benefits: [
      { title: "Real medicine, not supplements", body: "Compounded, clinician-prescribed protocols — not off-the-shelf pills." },
      { title: "Energy & metabolism", body: "MIC+B12 and L-Carnitine support cellular energy and fat metabolism." },
      { title: "Pairs with GLP-1", body: "Common adjuncts for patients on a weight-loss protocol who want more energy." },
      { title: "Lab-aware dosing", body: "Dosed and adjusted with your clinician — safely and effectively." },
    ],
    faq: [
      { q: "Do these help weight loss?", a: "They support it — best results stacked with a primary protocol like GLP-1." },
      { q: "Any stimulants?", a: "No — energy comes from better cellular metabolism, not caffeine." },
      { q: "Injection or oral?", a: "MIC+B12 and L-Carnitine are small weekly injections; DHEA is a daily capsule." },
      { q: "How fast will I feel it?", a: "Many patients notice an energy lift within the first week or two." },
    ],
  },
};

export const ALL_HUBS = Object.values(HUBS);
